export default __webpack_public_path__ + "static/media/@silviarossoficial.f3d02942.jpg";